import React from 'react';
import { Button } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';

interface TagManagerTableFooterProps {
  addButtonRef: React.RefObject<HTMLButtonElement>;
  categoryCount: number;
  hiddenCount: number;
  isAddOpen: boolean;
  panelId: string;
  visibleCount: number;
  onToggleAdd: () => void;
}

const TagManagerTableFooter = ({
  addButtonRef, categoryCount, hiddenCount, isAddOpen, panelId, visibleCount, onToggleAdd,
}: TagManagerTableFooterProps) => (
  <div className={cn(
    'tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-2',
    'tw-bg-light-grey tw-border-t tw-border-solid tw-border-light-grey',
  )}
  >
    <Text className="tw-text-very-dark-grey" data-testid="correlation-count" size="xs">
      {I18n.t('showing_x_of_y', { count: visibleCount, total: categoryCount })}
      {hiddenCount > 0 && ` · ${I18n.t('hidden_count', { count: hiddenCount })}`}
    </Text>
    <Button
      ref={addButtonRef}
      small
      aria-controls={panelId}
      aria-expanded={isAddOpen}
      className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1"
      onClick={onToggleAdd}
    >
      <Icon aria-hidden icon="Add" size={10} />
      {I18n.t('add_correlation')}
    </Button>
  </div>
);

export default TagManagerTableFooter;
